<template>
  <div id="wpcal_admin_app" :style="main_styles">
    <IconFillSVG />
    <!--<div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/event-types">Services</router-link> |
      <router-link to="/event-type/add">Add Service</router-link> |
      <router-link to="/event-type/edit/1">Edit Service 1</router-link> |
      <router-link to="/bookings">Bookings</router-link>
    </div> -->

    <router-view v-if="is_settings_loaded || !is_admin_end_access_granted" />
    <OnBoardingCheckList />
    <PricingCompareModal />
    <v-dialog
      style="z-index:10001;"
      @before-closed="event_bus.$emit('dialog-before-closed', $event)"
    />
    <!-- v-dialog @closed="event_bus.$emit('dialog-closed', $event)" -->
  </div>
</template>

<script>
import OnBoardingCheckList from "@/components/admin/OnBoardingCheckList.vue";
import PricingCompareModal from "@/components/admin/PricingCompareModal.vue";
import IconFillSVG from "@/assets/images/IconFillSVG.vue";

export default {
  components: {
    OnBoardingCheckList,
    PricingCompareModal,
    IconFillSVG
  },
  computed: {
    is_settings_loaded() {
      return !this._isEmpty(this.$store.getters.get_general_settings);
    },
    is_admin_end_access_granted() {
      return this.$store.getters.get_is_admin_end_access_granted;
    },
    main_styles() {
      let styles = {};
      let general_setting = this.$store.getters.get_general_settings;

      if (
        general_setting.hasOwnProperty("hide_premium_info_badges") &&
        general_setting.hide_premium_info_badges == "0"
      ) {
        styles["--hidePremiumInfoBadge"] = "block";
      }
      return styles;
    }
  },
  methods: {
    check_and_handle_license_info() {
      if (this.$store.getters.get_license_info === null) {
        //propably not data not loaded
        return;
      }
      if (this._isEmpty(this.$store.getters.get_license_info)) {
        //initial setup not done, ask admin for login
        this.$router.push("/settings/account/login");
      }
    }
  },
  watch: {
    "$store.getters.get_license_info": function() {
      this.check_and_handle_license_info();
    },
    is_admin_end_access_granted: function(val) {
      if (!val) {
        this.$router.push("/non_wpcal_admin");
      }
    }
  },
  created() {
    this.$store.dispatch("init");
  }
};
</script>

<style lang="scss">
#wpcal_admin_app {
  background-color: #eef3fc; //wpcal
}
</style>
<style src="@/assets/fonts/wf-stylesheet.css"></style>
<style src="@/assets/css/admin_app.css"></style>
